<template>
  <div
    class="relative cursor-pointer"
    @click="toggleDropdown"
    v-click-outside="
      () => {
        dropdownActive = false;
      }
    "
  >
    <div class="flex items-center space-x-2">
      <div class="flex items-center space-x-4">
        <div class="flex h-full items-center">
          <i
            v-html="
              itemLogo(
                getAccountTypes.selectedAccount.broker_name,
                getAccountTypes.selectedAccount.account_type
              )
            "
            class="h-11 w-11"
          ></i>
        </div>

        <div class="flex w-full flex-col">
          <span
            class="text-ontick-carbon-900 text-sm font-bold dark:text-gray-300"
          >
            {{ getAccountTypes.selectedAccount.broker_name }}
          </span>
          <div class="flex items-center space-x-4">
            <span class="text-ontick-carbon-900 text-sm dark:text-gray-400">
              #{{ getAccountTypes.selectedAccount.account_number }}
            </span>
            <span
              content="Estratégias em execução"
              v-tippy="{ arrow: true, theme: 'green' }"
              class="relative flex items-center"
            >
              <div
                v-show="getAccountTypes.selectedAccount.num_running > 0"
                class="bg-ontick-green-500 absolute mr-3 inline-flex h-3 w-3 animate-ping rounded-full opacity-75"
              ></div>

              <div
                class="h-3 w-3 rounded-full"
                :class="
                  getAccountTypes.selectedAccount.num_running == 0
                    ? 'bg-gray-400'
                    : 'bg-ontick-green-500'
                "
              ></div>
              <span class="text-ontick-carbon-900 mx-1 dark:text-gray-300">{{
                getAccountTypes.selectedAccount.num_running
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <div
        class="text-ontick-carbon-900 transform rounded-full transition-all ease-in-out disabled:bg-red-500 dark:text-gray-300"
        :class="dropdownActive ? '-rotate-90' : 'rotate-90'"
      >
        <i v-html="$icons.chevron_right"></i>
      </div>
    </div>
    <transition name="dropdown-slide">
      <ul
        v-if="dropdownActive"
        class="dark:bg-ontick-steel-500 absolute top-14 z-10 overflow-hidden rounded-lg bg-gray-50 shadow-md"
      >
        <li v-for="(item, index) in getAccountTypes.accounts" :key="index">
          <button
            @click="selectAccount(item)"
            class="text-ontick-carbon-900 dark:hover:bg-ontick-steel-600 flex w-full items-center space-x-2 px-2 py-4 hover:bg-gray-100 dark:text-gray-300"
          >
            <i
              v-html="itemLogo(item.broker_name, item.account_type)"
              class="h-6 w-6"
            ></i>
            <span class="text-xs font-bold">
              {{ item.broker_name }} ({{ item.account_number }})
            </span>
            <span
              content="Estratégias em execução"
              v-tippy="{ arrow: true, theme: 'green' }"
              class="relative flex items-center"
            >
              <div
                v-show="item.num_running > 0"
                class="bg-ontick-green-500 absolute mr-3 inline-flex h-3 w-3 animate-ping rounded-full opacity-75"
              ></div>

              <div
                class="h-3 w-3 rounded-full"
                :class="
                  item.num_running == 0 ? 'bg-gray-400' : 'bg-ontick-green-500'
                "
              ></div>
              <span class="text-ontick-carbon-900 mx-1 dark:text-gray-300">{{
                item.num_running
              }}</span>
            </span>
          </button>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ClickOutside from "vue-click-outside";
import NotificationAccountComponent from "../../../modules/notification/components/notification-account.component.vue";

export default {
  directives: {
    ClickOutside,
  },
  components: {
    NotificationAccountComponent,
  },
  data() {
    return {
      dropdownActive: false,
    };
  },
  computed: {
    ...mapGetters({
      getAccountTypes: "accountTypes/getAccountTypes",
      getUiTheme: "config/getUiTheme",
    }),
  },
  methods: {
    ...mapActions({ updateAccount: "accountTypes/updateAccount" }),
    selectAccount(item) {
      if (
        item.account_number !=
        this.getAccountTypes.selectedAccount.account_number
      ) {
        this.$swal({
          title: "Conta alterada",
          text: `Você está na conta ${item.broker_name}: ${
            item.account_type === "PRD" ? "PRODUÇÃO" : "DEMO"
          }`,
          timer: 5000,
          timerProgressBar: true,
          icon: "success",
          iconHtml: this.$icons.swal_success,
        });
        // this.dropdownActive = false;
        let params = { account: item, router: this.$route.path };
        if (
          this.getAccountTypes.selectedAccount.account_number !=
          item.account_number
        ) {
          this.updateAccount(params);
          this.$emit("account-selected");
        }
      }
    },
    toggleDropdown() {
      this.dropdownActive = !this.dropdownActive;
    },
    itemLogo(broker_name, account_type) {
      switch (broker_name) {
        case "OnTick":
          return this.$icons.ontick;

        case "XP":
          return this.$icons.xp;

        case "Cripto":
          return this.$icons.bitcoin;

        case "RICO":
          return this.$icons.rico_badge;

        case "CLEAR":
          return this.getUiTheme === "DARK"
            ? this.$icons.clear_light_badge
            : this.$icons.clear_dark_badge;

        case "XTAGE":
          return this.$icons.xtage_badge;
        case "Campeonato":
          return this.$icons.trophy;
      }
      if (account_type === "CONTEST") {
        return this.$icons.trophy;
      }
    },
  },
};
</script>

<style lang="scss">
.dropdown-slide {
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-200 ease-in-out;
  }

  &-enter,
  &-leave-to {
    @apply -translate-y-10 transform opacity-0;
  }
}
</style>
